export default __webpack_public_path__ + "static/media/Raffs-PizzaMenu.ecdf595d.pdf";